export default function setKeywordFilter(state, action) {
    const keywordFilter = action.keywordFilter;

    return {...state, keywordFilter};
}